module.exports = __webpack_public_path__ + "img/about-zainiac-banner-1900X850.3bde18a6.png";